import React, { Component } from 'react';
import PropTypes from 'prop-types';
import copyToClipboard from 'copy-to-clipboard';
import { withRouter } from 'react-router';
import {
  shouldShowNativeAppBanner,
  shouldShowPartnerRedirectionBanner,
} from 'common/util/isUserAgentMobileApp';
import branch from 'client/core/branch';
import SrLogo from 'client/components/SrLogo';
import SrNativeAppBanner from 'client/components/SrNativeAppBanner';
import SrNavbarToast from 'client/components/SrNavbarToast';
import SrPartnerRedirectionBanner from 'client/components/SrPartnerRedirectionBanner/SrPartnerRedirectionBanner';

@withRouter
@branch({
  currentUser: ['currentUser'],
  userAgent: ['analytics', 'userAgent'],
})
class Navbar extends Component {
  static propTypes = {
    leftButton: PropTypes.node,
    rightButton: PropTypes.node,
    customLogo: PropTypes.node,
    secondaryRightButton: PropTypes.node,
    redirectLogoTo: PropTypes.string,
    navbarToast: PropTypes.node,
    disableRedirect: PropTypes.bool,
    currentUser: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    hideNativeAppBanner: PropTypes.bool,
  };

  static defaultProps = {
    redirectLogoTo: '/feed',
  };

  constructor(props) {
    super(props);
    this.state = {
      showToast: false,
    };
    this._isUnmounting = false;
  }

  componentWillUnmount() {
    this._isUnmounting = true;
  }

  _onToggleToast = (event) => {
    const { rightButton } = this.props;

    const { toastLink, onClick } = rightButton.props;

    event.preventDefault();
    event.stopPropagation();

    this.setState({
      showToast: true,
    });
    setTimeout(() => {
      if (!this._unmounting) {
        this.setState({
          showToast: false,
        });
      }
    }, 2000);

    if (onClick) {
      onClick();
    }

    if (toastLink) {
      copyToClipboard(toastLink);
    }
  };

  render() {
    const {
      leftButton,
      rightButton,
      secondaryRightButton,
      redirectLogoTo,
      currentUser,
      navbarToast,
      disableRedirect,
      userAgent,
      location,
      hideNativeAppBanner,
      customLogo,
    } = this.props;

    const { showToast } = this.state;

    const showNativeAppBanner =
      !hideNativeAppBanner &&
      shouldShowNativeAppBanner({
        userAgent,
        currentUser,
        location,
      });

    const showPartnerRedirectionBanner = shouldShowPartnerRedirectionBanner({
      location,
      currentUser,
    });

    return (
      <div className="navbar-container">
        <div className="navbar small">
          {showNativeAppBanner && <SrNativeAppBanner />}
          {showPartnerRedirectionBanner && <SrPartnerRedirectionBanner />}
          <div className="navbarInner">
            <span className="link left">{leftButton}</span>
            {customLogo || <SrLogo redirectTo={redirectLogoTo} disableRedirect={disableRedirect} />}
            {secondaryRightButton && (
              <span
                className="link secondaryRight"
                onClick={(e) =>
                  secondaryRightButton &&
                  secondaryRightButton.props.toggleToast &&
                  this._onToggleToast(e)
                }
              >
                {secondaryRightButton}
              </span>
            )}
            <span
              className="link right"
              onClick={(e) =>
                rightButton && rightButton.props.toggleToast && this._onToggleToast(e)
              }
            >
              {rightButton}
            </span>
          </div>
          {showToast && (
            <SrNavbarToast toastContent={rightButton && rightButton.props.toastContent} />
          )}
          {navbarToast}
        </div>
      </div>
    );
  }
}

Navbar.displayName = 'Navbar';

export default Navbar;
